import { useParams, Link } from 'react-router-dom';

import { Box } from '@mui/material';

import PageSharePanel from 'components/PageSharePanel';

const Header = () => {

    const { currencyPair } = useParams();

    const getLinkClassName = (currencyPairLink) => (
        currencyPair === currencyPairLink ? 'pill pill-current' : 'pill'
    );
    
    return (
        <>
            <header>
                <div className="logo"><Link to="/">AI Exchange</Link></div>
                <nav>
                    <Box sx={{ mr: 5 }}>
                        <PageSharePanel />
                    </Box>
                    <Link to="/terms-and-conditions">Terms & Conditions</Link>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                </nav>
            </header>
            <div className="pill-bar">
                <Link to="/currency-pair/usd-eur" className={getLinkClassName('usd-eur')}>USD to EUR</Link>
                <Link to="/currency-pair/usd-jpy" className={getLinkClassName('usd-jpy')}>USD to JPY</Link>
                <Link to="/currency-pair/usd-gbp" className={getLinkClassName('usd-gbp')}>USD to GBP</Link>
                <Link to="/currency-pair/usd-chf" className={getLinkClassName('usd-chf')}>USD to CHF</Link>
                <Link to="/currency-pair/usd-aud" className={getLinkClassName('usd-aud')}>USD to AUD</Link>
                <Link to="/currency-pair/usd-cad" className={getLinkClassName('usd-cad')}>USD to CAD</Link>
                <Link to="/currency-pair/usd-nzd" className={getLinkClassName('usd-nzd')}>USD to NZD</Link>
                <Link to="/currency-pair/eur-gbp" className={getLinkClassName('eur-gbp')}>EUR to GBP</Link>
                <Link to="/currency-pair/eur-jpy" className={getLinkClassName('eur-jpy')}>EUR to JPY</Link>
                <Link to="/currency-pair/eur-chf" className={getLinkClassName('eur-chf')}>EUR to CHF</Link>
            </div>
        </>
    );
};

export default Header;